var map = {
	"./menu_bzzx.png": "./src/assets/menu/menu_bzzx.png",
	"./menu_ckgl.png": "./src/assets/menu/menu_ckgl.png",
	"./menu_ddgl.png": "./src/assets/menu/menu_ddgl.png",
	"./menu_gh.png": "./src/assets/menu/menu_gh.png",
	"./menu_gong.png": "./src/assets/menu/menu_gong.png",
	"./menu_home.png": "./src/assets/menu/menu_home.png",
	"./menu_jbpz.png": "./src/assets/menu/menu_jbpz.png",
	"./menu_khgl.png": "./src/assets/menu/menu_khgl.png",
	"./menu_rzgl.png": "./src/assets/menu/menu_rzgl.png",
	"./menu_shouye.png": "./src/assets/menu/menu_shouye.png",
	"./menu_sjcx.png": "./src/assets/menu/menu_sjcx.png",
	"./menu_spgl.png": "./src/assets/menu/menu_spgl.png",
	"./menu_wzxxgl.png": "./src/assets/menu/menu_wzxxgl.png",
	"./wx.png": "./src/assets/menu/wx.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/menu sync recursive ^\\.\\/.*\\.png$";